import {
  type DiagramPayload,
  SupportedMetamodels,
} from '@bizzdesign/modeler/models';
import { type UUID } from '@bizzdesign/bizzdesign-sdk/uuid';

export const onboardingFramePayload: DiagramPayload = {
  payload: {
    'bce2944f-9d94-4a17-893c-b1e7a65c8a8b': {
      version: '1.0',
      id: 'bce2944f-9d94-4a17-893c-b1e7a65c8a8b' as UUID,
      name: { en: 'Open "Quick Bite" app' },
      typeName: 'Box',
      metaModelTerm: 'FreeFormat:Box',
      parentId: null,
      semanticsId: null,
      style: {
        shape: {
          fill: [{ color: { r: 206, g: 225, b: 255 }, opacity: 250 }],
          stroke: { opacity: 255 },
        },
        sourceShape: { fill: [], stroke: { opacity: 255 } },
        targetShape: { fill: [], stroke: { opacity: 255 } },
        icons: [],
      },
      layout: { x: -455.75, y: -244.5, width: 120, height: 120 },
      elementKind: 'diagram',
      graphicKind: 3,
      shapeType: 'roundRectangle',
      zOrder: 10,
    },
    '0809efa4-895c-4f33-873c-47cf961116d8': {
      version: '1.0',
      id: '0809efa4-895c-4f33-873c-47cf961116d8' as UUID,
      name: { en: 'Log in to app' },
      typeName: 'Box',
      metaModelTerm: 'FreeFormat:Box',
      parentId: null,
      semanticsId: null,
      style: {
        shape: {
          fill: [{ color: { r: 206, g: 225, b: 255 }, opacity: 250 }],
          stroke: { opacity: 255 },
        },
        sourceShape: { fill: [], stroke: { opacity: 255 } },
        targetShape: { fill: [], stroke: { opacity: 255 } },
        icons: [],
      },
      layout: { x: -255.75, y: -244.5, width: 120, height: 120 },
      elementKind: 'diagram',
      graphicKind: 3,
      shapeType: 'roundRectangle',
      zOrder: 11,
    },
    'cf4bed99-aa2b-479d-a2a4-8f008f22ec02': {
      version: '1.0',
      id: 'cf4bed99-aa2b-479d-a2a4-8f008f22ec02' as UUID,
      name: { en: 'Select restaurant' },
      typeName: 'Box',
      metaModelTerm: 'FreeFormat:Box',
      parentId: null,
      semanticsId: null,
      style: {
        shape: {
          fill: [{ color: { r: 206, g: 225, b: 255 }, opacity: 250 }],
          stroke: { opacity: 255 },
        },
        sourceShape: { fill: [], stroke: { opacity: 255 } },
        targetShape: { fill: [], stroke: { opacity: 255 } },
        icons: [],
      },
      layout: { x: -76.75, y: -244.5, width: 120, height: 120 },
      elementKind: 'diagram',
      graphicKind: 3,
      shapeType: 'roundRectangle',
      zOrder: 12,
    },
    '90ccc95d-f2f5-4d7c-a83c-688fff823272': {
      version: '1.0',
      id: '90ccc95d-f2f5-4d7c-a83c-688fff823272' as UUID,
      name: { en: 'User database' },
      typeName: 'Box',
      metaModelTerm: 'FreeFormat:Box',
      parentId: null,
      semanticsId: null,
      style: {
        shape: { fill: [] },
        sourceShape: { fill: [] },
        targetShape: { fill: [] },
        icons: [],
      },
      layout: { x: -277.875, y: -369.25, width: 164.25, height: 65.75 },
      elementKind: 'diagram',
      graphicKind: 3,
      promotion: {
        metamodelName: SupportedMetamodels.BDCORE,
        typeName: 'Data',
      },
      zOrder: 13,
    },
    '3e3d32cc-78f2-4bfd-91ae-d963b7c034eb': {
      version: '1.0',
      id: '3e3d32cc-78f2-4bfd-91ae-d963b7c034eb' as UUID,
      name: { en: 'Select food' },
      typeName: 'Box',
      metaModelTerm: 'FreeFormat:Box',
      parentId: null,
      semanticsId: null,
      style: {
        shape: {
          fill: [{ color: { r: 206, g: 225, b: 255 }, opacity: 250 }],
          stroke: { opacity: 255 },
        },
        sourceShape: { fill: [], stroke: { opacity: 255 } },
        targetShape: { fill: [], stroke: { opacity: 255 } },
        icons: [],
      },
      layout: { x: 102.25, y: -244.5, width: 120, height: 120 },
      elementKind: 'diagram',
      graphicKind: 3,
      shapeType: 'roundRectangle',
      zOrder: 14,
    },
    '31340489-f324-4a3d-9d2b-81b4695279e1': {
      version: '1.0',
      id: '31340489-f324-4a3d-9d2b-81b4695279e1' as UUID,
      name: { en: 'View cart' },
      typeName: 'Box',
      metaModelTerm: 'FreeFormat:Box',
      parentId: null,
      semanticsId: null,
      style: {
        shape: {
          fill: [{ color: { r: 206, g: 225, b: 255 }, opacity: 250 }],
          stroke: { opacity: 255 },
        },
        sourceShape: { fill: [], stroke: { opacity: 255 } },
        targetShape: { fill: [], stroke: { opacity: 255 } },
        icons: [],
      },
      layout: { x: 281.25, y: -244.5, width: 120, height: 120 },
      elementKind: 'diagram',
      graphicKind: 3,
      shapeType: 'roundRectangle',
      zOrder: 15,
    },
    'a6d88a87-1dc8-4a4a-b5fa-8c82794e6936': {
      version: '1.0',
      id: 'a6d88a87-1dc8-4a4a-b5fa-8c82794e6936' as UUID,
      name: { en: 'Pay' },
      typeName: 'Box',
      metaModelTerm: 'FreeFormat:Box',
      parentId: null,
      semanticsId: null,
      style: {
        shape: {
          fill: [{ color: { r: 206, g: 225, b: 255 }, opacity: 250 }],
          stroke: { opacity: 255 },
        },
        sourceShape: { fill: [], stroke: { opacity: 255 } },
        targetShape: { fill: [], stroke: { opacity: 255 } },
        icons: [],
      },
      layout: { x: 460.25, y: -244.5, width: 120, height: 120 },
      elementKind: 'diagram',
      graphicKind: 3,
      shapeType: 'roundRectangle',
      zOrder: 16,
    },
    '0d422418-3eeb-4c80-b36d-a0c1e86c14f4': {
      version: '1.0',
      id: '0d422418-3eeb-4c80-b36d-a0c1e86c14f4' as UUID,
      name: { en: 'Receive confirmation' },
      typeName: 'Box',
      metaModelTerm: 'FreeFormat:Box',
      parentId: null,
      semanticsId: null,
      style: {
        shape: {
          fill: [{ color: { r: 206, g: 225, b: 255 }, opacity: 250 }],
          stroke: { opacity: 255 },
        },
        sourceShape: { fill: [], stroke: { opacity: 255 } },
        targetShape: { fill: [], stroke: { opacity: 255 } },
        icons: [],
      },
      layout: { x: 859, y: -244.5, width: 120, height: 120 },
      elementKind: 'diagram',
      graphicKind: 3,
      shapeType: 'roundRectangle',
      zOrder: 17,
    },
    '159e1c7d-8d30-4d36-824a-073f5c23ff22': {
      version: '1.0',
      id: '159e1c7d-8d30-4d36-824a-073f5c23ff22' as UUID,
      name: { en: 'Ask Jane how confirmation works' },
      typeName: 'Box',
      metaModelTerm: 'FreeFormat:Box',
      parentId: null,
      semanticsId: null,
      style: {
        shape: {
          fill: [{ color: { r: 250, g: 224, b: 0 }, opacity: 250 }],
          stroke: { opacity: 255 },
          font: { family: 'Kalam' },
        },
        sourceShape: { fill: [], stroke: { opacity: 255 } },
        targetShape: { fill: [], stroke: { opacity: 255 } },
        icons: [],
      },
      layout: { x: 891.75, y: -104.5, width: 120, height: 120 },
      elementKind: 'diagram',
      graphicKind: 3,
      shapeType: 'sticker',
      zOrder: 18,
    },
    '167718e2-c38e-4810-baee-f26b08a7ab4c': {
      version: '1.0',
      id: '167718e2-c38e-4810-baee-f26b08a7ab4c' as UUID,
      name: { en: 'Payment process' },
      typeName: 'Box',
      metaModelTerm: 'FreeFormat:Box',
      parentId: null,
      semanticsId: null,
      style: {
        shape: { fill: [] },
        sourceShape: { fill: [] },
        targetShape: { fill: [] },
        icons: [],
      },
      layout: { x: 438.125, y: -369.25, width: 164.25, height: 65.75 },
      elementKind: 'diagram',
      graphicKind: 3,
      promotion: {
        metamodelName: SupportedMetamodels.BDCORE,
        typeName: 'Process',
      },
      zOrder: 19,
    },
    '923f1fca-0f37-411e-a154-68d4ec13ec98': {
      version: '1.0',
      id: '923f1fca-0f37-411e-a154-68d4ec13ec98' as UUID,
      name: { en: 'Notify restaurant' },
      typeName: 'Box',
      metaModelTerm: 'FreeFormat:Box',
      parentId: null,
      semanticsId: null,
      style: {
        shape: {
          fill: [{ color: { r: 206, g: 225, b: 255 }, opacity: 250 }],
          stroke: { opacity: 255 },
        },
        sourceShape: { fill: [], stroke: { opacity: 255 } },
        targetShape: { fill: [], stroke: { opacity: 255 } },
        icons: [],
      },
      layout: { x: 662.75, y: -244.5, width: 120, height: 120 },
      elementKind: 'diagram',
      graphicKind: 3,
      shapeType: 'roundRectangle',
      zOrder: 20,
    },
    '30d71ef8-fca0-4a88-aae7-ed7678f2cf3d': {
      version: '1.0',
      id: '30d71ef8-fca0-4a88-aae7-ed7678f2cf3d' as UUID,
      name: { en: '' },
      typeName: 'Line',
      metaModelTerm: 'FreeFormat:Line',
      parentId: null,
      semanticsId: null,
      style: {
        shape: {
          fill: [{ color: { r: 206, g: 225, b: 255 }, opacity: 250 }],
          stroke: { opacity: 255 },
          label: {
            positionOffset: [
              {
                linkFoldingStateId: {
                  linkId: '30d71ef8-fca0-4a88-aae7-ed7678f2cf3d',
                  sourceId: 'bce2944f-9d94-4a17-893c-b1e7a65c8a8b',
                  sourceCollapsed: false,
                  targetId: '0809efa4-895c-4f33-873c-47cf961116d8',
                  targetCollapsed: false,
                },
                positionOffset: { x: 0, y: 0 },
              },
            ],
          },
        },
        sourceShape: { fill: [], stroke: { opacity: 255 } },
        targetShape: { fill: [], stroke: { opacity: 255 } },
        icons: [],
      },
      sourceId: 'bce2944f-9d94-4a17-893c-b1e7a65c8a8b',
      targetId: '0809efa4-895c-4f33-873c-47cf961116d8',
      sourcePoint: { x: -395.75, y: -184.5 },
      targetPoint: { x: -195.75, y: -184.5 },
      points: [],
      elementKind: 'diagram',
      graphicKind: 2,
      sourcePointParentId: 'd0',
      targetPointParentId: 'd0',
      zOrder: 1,
    },
    '1ea20755-d104-4117-ba54-9e31b890c3f7': {
      version: '1.0',
      id: '1ea20755-d104-4117-ba54-9e31b890c3f7' as UUID,
      name: { en: '' },
      typeName: 'Line',
      metaModelTerm: 'FreeFormat:Line',
      parentId: null,
      semanticsId: null,
      style: {
        shape: {
          fill: [{ color: { r: 206, g: 225, b: 255 }, opacity: 250 }],
          stroke: { opacity: 255 },
          label: {
            positionOffset: [
              {
                linkFoldingStateId: {
                  linkId: '1ea20755-d104-4117-ba54-9e31b890c3f7',
                  sourceId: '0809efa4-895c-4f33-873c-47cf961116d8',
                  sourceCollapsed: false,
                  targetId: 'cf4bed99-aa2b-479d-a2a4-8f008f22ec02',
                  targetCollapsed: false,
                },
                positionOffset: { x: 0, y: 0 },
              },
            ],
          },
        },
        sourceShape: { fill: [], stroke: { opacity: 255 } },
        targetShape: { fill: [], stroke: { opacity: 255 } },
        icons: [],
      },
      sourceId: '0809efa4-895c-4f33-873c-47cf961116d8',
      targetId: 'cf4bed99-aa2b-479d-a2a4-8f008f22ec02',
      sourcePoint: { x: -195.75, y: -184.5 },
      targetPoint: { x: -16.75, y: -184.5 },
      points: [],
      elementKind: 'diagram',
      graphicKind: 2,
      sourcePointParentId: 'd0',
      targetPointParentId: 'd0',
      zOrder: 2,
    },
    '3ff551c5-d56d-4379-9655-0544bf5c0fa2': {
      version: '1.0',
      id: '3ff551c5-d56d-4379-9655-0544bf5c0fa2' as UUID,
      name: { en: '' },
      typeName: 'Line',
      metaModelTerm: 'FreeFormat:Line',
      parentId: null,
      semanticsId: null,
      style: {
        shape: {
          fill: [],
          label: {
            positionOffset: [
              {
                linkFoldingStateId: {
                  linkId: '3ff551c5-d56d-4379-9655-0544bf5c0fa2',
                  sourceId: '0809efa4-895c-4f33-873c-47cf961116d8',
                  sourceCollapsed: false,
                  targetId: '90ccc95d-f2f5-4d7c-a83c-688fff823272',
                  targetCollapsed: false,
                },
                positionOffset: { x: 0, y: 0 },
              },
            ],
          },
        },
        sourceShape: { fill: [] },
        targetShape: { fill: [] },
        icons: [],
      },
      sourceId: '0809efa4-895c-4f33-873c-47cf961116d8',
      targetId: '90ccc95d-f2f5-4d7c-a83c-688fff823272',
      sourcePoint: { x: -195.75, y: -184.5 },
      targetPoint: { x: -195.75, y: -336.375 },
      points: [
        { x: -195.75, y: -274 },
        { x: -195.75, y: -274 },
      ],
      elementKind: 'diagram',
      graphicKind: 2,
      sourcePointParentId: 'd0',
      targetPointParentId: 'd0',
      zOrder: 3,
    },
    '2556d2d8-34a2-4605-9cca-e71928fa0789': {
      version: '1.0',
      id: '2556d2d8-34a2-4605-9cca-e71928fa0789' as UUID,
      name: { en: '' },
      typeName: 'Line',
      metaModelTerm: 'FreeFormat:Line',
      parentId: null,
      semanticsId: null,
      style: {
        shape: {
          fill: [{ color: { r: 206, g: 225, b: 255 }, opacity: 250 }],
          stroke: { opacity: 255 },
          label: {
            positionOffset: [
              {
                linkFoldingStateId: {
                  linkId: '2556d2d8-34a2-4605-9cca-e71928fa0789',
                  sourceId: 'cf4bed99-aa2b-479d-a2a4-8f008f22ec02',
                  sourceCollapsed: false,
                  targetId: '3e3d32cc-78f2-4bfd-91ae-d963b7c034eb',
                  targetCollapsed: false,
                },
                positionOffset: { x: 0, y: 0 },
              },
            ],
          },
        },
        sourceShape: { fill: [], stroke: { opacity: 255 } },
        targetShape: { fill: [], stroke: { opacity: 255 } },
        icons: [],
      },
      sourceId: 'cf4bed99-aa2b-479d-a2a4-8f008f22ec02',
      targetId: '3e3d32cc-78f2-4bfd-91ae-d963b7c034eb',
      sourcePoint: { x: -16.75, y: -184.5 },
      targetPoint: { x: 162.25, y: -184.5 },
      points: [],
      elementKind: 'diagram',
      graphicKind: 2,
      sourcePointParentId: 'd0',
      targetPointParentId: 'd0',
      zOrder: 4,
    },
    'a66c449d-9def-4bcf-8d32-a92c5e3cf9a0': {
      version: '1.0',
      id: 'a66c449d-9def-4bcf-8d32-a92c5e3cf9a0' as UUID,
      name: { en: '' },
      typeName: 'Line',
      metaModelTerm: 'FreeFormat:Line',
      parentId: null,
      semanticsId: null,
      style: {
        shape: {
          fill: [{ color: { r: 206, g: 225, b: 255 }, opacity: 250 }],
          stroke: { opacity: 255 },
          label: {
            positionOffset: [
              {
                linkFoldingStateId: {
                  linkId: 'a66c449d-9def-4bcf-8d32-a92c5e3cf9a0',
                  sourceId: '3e3d32cc-78f2-4bfd-91ae-d963b7c034eb',
                  sourceCollapsed: false,
                  targetId: '31340489-f324-4a3d-9d2b-81b4695279e1',
                  targetCollapsed: false,
                },
                positionOffset: { x: 0, y: 0 },
              },
            ],
          },
        },
        sourceShape: { fill: [], stroke: { opacity: 255 } },
        targetShape: { fill: [], stroke: { opacity: 255 } },
        icons: [],
      },
      sourceId: '3e3d32cc-78f2-4bfd-91ae-d963b7c034eb',
      targetId: '31340489-f324-4a3d-9d2b-81b4695279e1',
      sourcePoint: { x: 162.25, y: -184.5 },
      targetPoint: { x: 341.25, y: -184.5 },
      points: [],
      elementKind: 'diagram',
      graphicKind: 2,
      sourcePointParentId: 'd0',
      targetPointParentId: 'd0',
      zOrder: 5,
    },
    'fe7399ad-1a03-4aef-b4ef-411b6af9983c': {
      version: '1.0',
      id: 'fe7399ad-1a03-4aef-b4ef-411b6af9983c' as UUID,
      name: { en: '' },
      typeName: 'Line',
      metaModelTerm: 'FreeFormat:Line',
      parentId: null,
      semanticsId: null,
      style: {
        shape: {
          fill: [{ color: { r: 206, g: 225, b: 255 }, opacity: 250 }],
          stroke: { opacity: 255 },
          label: {
            positionOffset: [
              {
                linkFoldingStateId: {
                  linkId: 'fe7399ad-1a03-4aef-b4ef-411b6af9983c',
                  sourceId: '31340489-f324-4a3d-9d2b-81b4695279e1',
                  sourceCollapsed: false,
                  targetId: 'a6d88a87-1dc8-4a4a-b5fa-8c82794e6936',
                  targetCollapsed: false,
                },
                positionOffset: { x: 0, y: 0 },
              },
            ],
          },
        },
        sourceShape: { fill: [], stroke: { opacity: 255 } },
        targetShape: { fill: [], stroke: { opacity: 255 } },
        icons: [],
      },
      sourceId: '31340489-f324-4a3d-9d2b-81b4695279e1',
      targetId: 'a6d88a87-1dc8-4a4a-b5fa-8c82794e6936',
      sourcePoint: { x: 341.25, y: -184.5 },
      targetPoint: { x: 520.25, y: -184.5 },
      points: [],
      elementKind: 'diagram',
      graphicKind: 2,
      sourcePointParentId: 'd0',
      targetPointParentId: 'd0',
      zOrder: 6,
    },
    '6a036faa-ee2a-4682-bc6f-b27f04904f57': {
      version: '1.0',
      id: '6a036faa-ee2a-4682-bc6f-b27f04904f57' as UUID,
      name: { en: '' },
      typeName: 'Line',
      metaModelTerm: 'FreeFormat:Line',
      parentId: null,
      semanticsId: null,
      style: {
        shape: {
          fill: [],
          label: {
            positionOffset: [
              {
                linkFoldingStateId: {
                  linkId: '6a036faa-ee2a-4682-bc6f-b27f04904f57',
                  sourceId: 'a6d88a87-1dc8-4a4a-b5fa-8c82794e6936',
                  sourceCollapsed: false,
                  targetId: '167718e2-c38e-4810-baee-f26b08a7ab4c',
                  targetCollapsed: false,
                },
                positionOffset: { x: 0, y: 0 },
              },
            ],
          },
        },
        sourceShape: { fill: [] },
        targetShape: { fill: [] },
        icons: [],
      },
      sourceId: 'a6d88a87-1dc8-4a4a-b5fa-8c82794e6936',
      targetId: '167718e2-c38e-4810-baee-f26b08a7ab4c',
      sourcePoint: { x: 520.25, y: -184.5 },
      targetPoint: { x: 520.25, y: -336.375 },
      points: [],
      elementKind: 'diagram',
      graphicKind: 2,
      sourcePointParentId: 'd0',
      targetPointParentId: 'd0',
      zOrder: 7,
    },
    'ad195981-ec6f-4035-bc17-1608d86f44b5': {
      version: '1.0',
      id: 'ad195981-ec6f-4035-bc17-1608d86f44b5' as UUID,
      name: { en: '' },
      typeName: 'Line',
      metaModelTerm: 'FreeFormat:Line',
      parentId: null,
      semanticsId: null,
      style: {
        shape: {
          fill: [{ color: { r: 206, g: 225, b: 255 }, opacity: 250 }],
          stroke: { opacity: 255 },
          label: {
            positionOffset: [
              {
                linkFoldingStateId: {
                  linkId: 'ad195981-ec6f-4035-bc17-1608d86f44b5',
                  sourceId: 'a6d88a87-1dc8-4a4a-b5fa-8c82794e6936',
                  sourceCollapsed: false,
                  targetId: '923f1fca-0f37-411e-a154-68d4ec13ec98',
                  targetCollapsed: false,
                },
                positionOffset: { x: 0, y: 0 },
              },
            ],
          },
        },
        sourceShape: { fill: [], stroke: { opacity: 255 } },
        targetShape: { fill: [], stroke: { opacity: 255 } },
        icons: [],
      },
      sourceId: 'a6d88a87-1dc8-4a4a-b5fa-8c82794e6936',
      targetId: '923f1fca-0f37-411e-a154-68d4ec13ec98',
      sourcePoint: { x: 520.25, y: -184.5 },
      targetPoint: { x: 722.75, y: -184.5 },
      points: [],
      elementKind: 'diagram',
      graphicKind: 2,
      sourcePointParentId: 'd0',
      targetPointParentId: 'd0',
      zOrder: 8,
    },
    '0ccedaff-22cb-4ca4-9a92-c4a981a92e61': {
      version: '1.0',
      id: '0ccedaff-22cb-4ca4-9a92-c4a981a92e61' as UUID,
      name: { en: '' },
      typeName: 'Line',
      metaModelTerm: 'FreeFormat:Line',
      parentId: null,
      semanticsId: null,
      style: {
        shape: {
          fill: [{ color: { r: 206, g: 225, b: 255 }, opacity: 250 }],
          stroke: { opacity: 255 },
          label: {
            positionOffset: [
              {
                linkFoldingStateId: {
                  linkId: '0ccedaff-22cb-4ca4-9a92-c4a981a92e61',
                  sourceId: '923f1fca-0f37-411e-a154-68d4ec13ec98',
                  sourceCollapsed: false,
                  targetId: '0d422418-3eeb-4c80-b36d-a0c1e86c14f4',
                  targetCollapsed: false,
                },
                positionOffset: { x: 0, y: 0 },
              },
            ],
          },
        },
        sourceShape: { fill: [], stroke: { opacity: 255 } },
        targetShape: { fill: [], stroke: { opacity: 255 } },
        icons: [],
      },
      sourceId: '923f1fca-0f37-411e-a154-68d4ec13ec98',
      targetId: '0d422418-3eeb-4c80-b36d-a0c1e86c14f4',
      sourcePoint: { x: 722.75, y: -184.5 },
      targetPoint: { x: 919, y: -184.5 },
      points: [],
      elementKind: 'diagram',
      graphicKind: 2,
      sourcePointParentId: 'd0',
      targetPointParentId: 'd0',
      zOrder: 9,
    },
  },
  fromRepoElements: [],
  metamodelMetadata: {
    currentMetamodelName: SupportedMetamodels.FREEFORMAT,
    convertFromPartialTargetMetamodel: false,
  },
  stateToken: '',
};
